import React from "react";

export const LogoutSidebarIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.2 22H9.8C13 22 15 20 15 16.8L15 12.75H8.75C8.34 12.75 8 12.41 8 12C8 11.59 8.34 11.25 8.75 11.25H15V7.2C15 4 13 2 9.8 2H7.21C4.01 2 2.01 4 2.01 7.2L2.01 16.8C2 20 4 22 7.2 22Z"
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M19.4401 12.7502L17.3701 14.8202C17.2201 14.9702 17.1501 15.1602 17.1501 15.3502C17.1501 15.5402 17.2201 15.7402 17.3701 15.8802C17.6601 16.1702 18.1401 16.1702 18.4301 15.8802L21.7801 12.5302C22.0701 12.2402 22.0701 11.7602 21.7801 11.4702L18.4301 8.12016C18.1401 7.83016 17.6601 7.83016 17.3701 8.12016C17.0801 8.41016 17.0801 8.89016 17.3701 9.18016L19.4401 11.2502H15.0001V12.7502H19.4401Z"
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
